import { createContext, useContext } from 'react';

/**
 * Identifies the workspace pane a subtree is rendering inside — `null` when
 * the app is rendering full screen. Lets shared chrome (MainLayout,
 * ScrollToTop) behave differently in a pane without any prop drilling.
 */
const PaneContext = createContext<string | null>(null);

export const PaneProvider = PaneContext.Provider;

export function usePaneId(): string | null {
  return useContext(PaneContext);
}
